import { render, staticRenderFns } from "./generalOnput.vue?vue&type=template&id=6a3575d6&scoped=true&"
import script from "./generalOnput.vue?vue&type=script&lang=js&"
export * from "./generalOnput.vue?vue&type=script&lang=js&"
import style0 from "./generalOnput.vue?vue&type=style&index=0&id=6a3575d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3575d6",
  null
  
)

export default component.exports